export const NON_EDITABLE_ROWS = [
  'total',
  'subtotal',
  'group',
  'control',
  'hashed',
]
